var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-product", attrs: { id: "jMenuProducts" } },
    _vm._l(_vm.products, function(product) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: product.isShow,
              expression: "product.isShow"
            }
          ],
          key: product.name,
          staticClass: "product"
        },
        [
          _c(
            "div",
            [
              product.href
                ? _c(
                    "router-link",
                    {
                      staticClass: "menu-product__lists product product-icon",
                      attrs: { to: product.href, tag: "a", "exact-path": "" }
                    },
                    [
                      _c("div", { staticClass: "image" }, [
                        _c("img", { attrs: { src: product.img } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "product-label" }, [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(product.name) +
                              "\n          "
                          )
                        ])
                      ])
                    ]
                  )
                : product.hrefout
                ? _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "menu-product__lists product product-icon",
                        attrs: { href: product.hrefout }
                      },
                      [
                        _c("div", { staticClass: "image" }, [
                          _c("img", { attrs: { src: product.img } })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "product-label" }, [
                          _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(product.name) +
                                "\n            "
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0f4a1cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0f4a1cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/jMenuProducts.vue
// module id = null
// module chunks = 